import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-website-detailed-tabs',
  templateUrl: './website-detailed-tabs.component.html'
})
export class WebsiteDetailedTabsComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() module
  active = 0
  constructor() {
  }

  ngOnInit() {
  }
}
